// DateRangePicker.jsx
import React from 'react';
import { DateRange } from 'react-date-range';
import { motion } from 'framer-motion';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const DateRangePicker = ({ dateRange, setDateRange, style, anchorRect }) => {
  const floating = Boolean(anchorRect);
  const baseStyle = floating
    ? {
        position: 'fixed',
        top: anchorRect?.top ?? 48,
        left: anchorRect?.left ?? 'auto',
        zIndex: 1400,
        width: anchorRect?.width || 360,
        maxWidth: 'calc(100vw - 24px)',
        backgroundColor: 'white',
        border: '1px solid #d1d5db',
        borderRadius: '12px',
        boxShadow: '0 16px 40px rgba(15, 23, 42, 0.22)',
        padding: 16,
      }
    : {
        position: 'absolute',
        top: '40px',
        left: '0',
        right: 'auto',
        zIndex: 1000,
        backgroundColor: 'white',
        border: '1px solid #ccc',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        padding: '16px',
      };
  const containerStyle = { ...baseStyle, ...style };
  const handleClick = (e) => {
    e.stopPropagation();
  };
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.2 }}
      style={containerStyle}
      onClick={handleClick}
    >
      <DateRange
        editableDateInputs
        onChange={(item) => setDateRange([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={dateRange}
      />
    </motion.div>
  );
};

export default DateRangePicker;
